import React, { useState } from "react";
import { motion } from "framer-motion";

const NotificationSettings = () => {
  const modules = [
    {
      title: "New Hire and Onboarding Notifications",
      desc: "Alerts when a new hire is added to the system",
    },
    {
      title: "Time Off and Leave Requests",
      desc: "Notifications when leave requests are approved or rejected",
    },
    {
      title: "Employee Performance and Review Updates",
      desc: "Notifications about performance updates",
    },
    {
      title: "Payroll and Compensation",
      desc: "Alerts when payroll is processed or pending approval",
    },
    {
      title: "Job Application and Recruitment",
      desc: "Alerts for new applications or stage updates",
    },
  ];

  const [switchState, setSwitchState] = useState(
    modules.map(() => ({
      push: false,
      sms: false,
      email: false,
    })),
  );

  const handleToggle = (index, type) => {
    const updated = [...switchState];
    updated[index][type] = !updated[index][type];
    setSwitchState(updated);
  };

  // 🔥 Snap animation variants
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.08,
      },
    },
  };

  const row = {
    hidden: { opacity: 0, y: 20, scale: 0.98 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 260,
        damping: 18,
      },
    },
  };

  return (
    <div >
      {/* Card Snap */}
      <motion.div
        className="container py-3 card"
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 15 }}
      >
        <motion.h5
          className="fw-semibold mb-3 text-primary"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          Notifications
        </motion.h5>
        <div >
          <div className="row fw-bold border-bottom pb-2">


            <div className="col-6">Modules</div>
            <div className="col-2 text-center">Push</div>
            <div className="col-2 text-center">SMS</div>
            <div className="col-2 text-center">Email</div>
          </div>

          {/* 🔥 Stagger container */}
          <motion.div className="card shadow-sm border-0 p-4" variants={container} initial="hidden" animate="visible">
            {modules.map((item, index) => (
              <motion.div
                key={index}
                variants={row}
                className="row align-items-center border-bottom py-3"
              >
                <div className="col-6">
                  <h6 className="mb-1 text-black">{item.title}</h6>
                  <small className="text-muted">{item.desc}</small>
                </div>

                {/* PUSH */}
                <div className="col-2 text-center">
                  <motion.button
                    whileTap={{ scale: 0.85 }}
                    animate={{
                      scale: switchState[index].push ? 1.1 : 1,
                    }}
                    transition={{ type: "spring", stiffness: 300 }}
                    className={`toggle-btn ${switchState[index].push ? "active" : ""
                      }`}
                    onClick={() => handleToggle(index, "push")}
                  >
                    <span className="circle"></span>
                  </motion.button>
                </div>

                {/* SMS */}
                <div className="col-2 text-center">
                  <motion.button
                    whileTap={{ scale: 0.85 }}
                    animate={{
                      scale: switchState[index].sms ? 1.1 : 1,
                    }}
                    transition={{ type: "spring", stiffness: 300 }}
                    className={`toggle-btn ${switchState[index].sms ? "active" : ""
                      }`}
                    onClick={() => handleToggle(index, "sms")}
                  >
                    <span className="circle"></span>
                  </motion.button>
                </div>

                {/* EMAIL */}
                <div className="col-2 text-center">
                  <motion.button
                    whileTap={{ scale: 0.85 }}
                    animate={{
                      scale: switchState[index].email ? 1.1 : 1,
                    }}
                    transition={{ type: "spring", stiffness: 300 }}
                    className={`toggle-btn ${switchState[index].email ? "active" : ""
                      }`}
                    onClick={() => handleToggle(index, "email")}
                  >
                    <span className="circle"></span>
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.div>

      <style>
        {`
        .toggle-btn {
          width: 42px;
          height: 22px;
          background: #dee2e6;
          border-radius: 20px;
          border: none;
          position: relative;
          cursor: pointer;
          transition: background 0.25s ease-in-out;
        }

        .toggle-btn .circle {
          width: 18px;
          height: 18px;
          background: #fff;
          border-radius: 50%;
          position: absolute;
          top: 2px;
          left: 2px;
          transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .toggle-btn.active {
          background: #198754;
        }

        .toggle-btn.active .circle {
          transform: translateX(20px);
        }
        `}
      </style>
    </div>
  );
};
export default NotificationSettings;
